import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"]
  static values = {
    successMessage: { type: String, default: "Copied." },
    errorMessage: { type: String, default: "Could not copy. Please copy manually." },
  }

  async copy(event) {
    event?.preventDefault()

    const text = this.sourceText
    if (!text) {
      this.showToast(this.errorMessageValue, "error")
      return
    }

    try {
      await this.writeToClipboard(text)
      this.showToast(this.successMessageValue, "success")
    } catch (_error) {
      this.showToast(this.errorMessageValue, "error")
    }
  }

  async writeToClipboard(text) {
    if (navigator.clipboard?.writeText && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      return
    }

    this.legacyCopy(text)
  }

  legacyCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "readonly")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()

    const copied = document.execCommand("copy")
    document.body.removeChild(textarea)

    if (!copied) {
      throw new Error("copy_failed")
    }
  }

  showToast(message, kind = "info") {
    window.dispatchEvent(
      new CustomEvent("toast:show", {
        detail: { message, kind },
      }),
    )
  }

  get sourceText() {
    return this.hasSourceTarget ? this.sourceTarget.value.toString().trim() : ""
  }
}
